export default {
    TFS_TIMER_TICK: 'tfs_timer_tick',
    INIT_DATA_LOADED: 'init_data_loaded',
    GAME_INITIALIZED: 'game_data_initialized',
    PREGAME_UPDATE: 'pregame_update',
    GAME_STATE_UPDATE: 'game_state_changed',
    UPDATE: 'abstract_update',
    UPDATE_EXTERNAL: 'abstract_update_external',
    TIMECODE: 'timecode_update',
    PATCH_ERROR: 'patch_error',
    GAME_SWITCH_COMPLETE: 'game_switch_complete',
    UPDATE_GAMEDAY_URL: 'update_gameday_url',
    NEW_TIMECODE: 'new_timecode',
    NEW_VALID_TIMECODE: 'new_valid_timecode',
    TK_SOCKET_INITIATED_FAILOVER: 'socket_initiated_failover',
    RECOVER_FULL_GUMBO: 'recover_full_gumbo',
    CONNECTION_ERROR: 'connection_error'
};
